var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5.1a.6.6 0 0 1 .6.6v15.6a.6.6 0 0 1-.18.42.59.59 0 0 1-.84 0 .6.6 0 0 1-.17-.42V.7a.6.6 0 0 1 .17-.42A.59.59 0 0 1 9.5.1Zm9.28 7.98a.6.6 0 0 1 0 .84l-2.37 2.4a.6.6 0 0 1-.64.14.6.6 0 0 1-.32-.33.6.6 0 0 1 .13-.65l1.35-1.38h-4.48a.59.59 0 0 1-.41-.18.6.6 0 0 1 0-.84.59.59 0 0 1 .41-.18h4.48l-1.35-1.38a.6.6 0 0 1 0-.84.59.59 0 0 1 .83 0l2.37 2.4ZM7.14 8.5a.6.6 0 0 1-.18.42.59.59 0 0 1-.41.18H2.07l1.35 1.38a.6.6 0 0 1 0 .84.59.59 0 0 1-.83 0L.22 8.92a.6.6 0 0 1-.12-.65.6.6 0 0 1 .12-.2l2.37-2.4a.6.6 0 0 1 .64-.12.6.6 0 0 1 .2.98L2.06 7.9h4.48c.15 0 .3.06.41.18a.6.6 0 0 1 .18.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSplit);
export default ForwardRef;